<template>
    <div :class="{
        'address-list': !Object.keys($route.query).some(k => /^lp/i.test(k))
    }">
        <van-skeleton :row="2" v-if="loading" />
        <van-empty v-else-if="!recipients.length" description="暂无收件信息"></van-empty>
        <van-address-list
            v-model="selectedId"
            :list="recipients"
            default-tag-text="默认"
            :switchable="!!from"
            :add-button-text="from &amp;&amp; &quot;确认&quot;"
            @add="onAdd"
            @edit="onEdit"
        ></van-address-list>
    </div>
</template>

<script>
import { getRecipients } from '@/service/member'
import { ADDRESS_ID } from '@/configs/constants'
import { setStorage, getStorage } from '@/utils/sessionStorage'
export default {
    props: ['from'],
    data() {
        return {
            recipients: [],
            selectedId: null,
            loading: true
        }
    },
    methods: {
        onAdd() {
            if (this.from) {
                this.confirm()
            } else {
                this.$router.push({ name: 'newAddress', query: { from: this.from } })
            }
        },
        onEdit({ id }) {
            this.$router.push({ name: 'editAddress', params: { id }, query: { from: this.from } })
        },
        async initData() {
            this.recipients = (await getRecipients()).data.map(item => {
                const { name, id, isDefault, phone, address: { province, district, city, details } } = item
                return {
                    id,
                    tel: phone,
                    address: province + city + district + details,
                    name,
                    isDefault
                }
            })
            const id = getStorage(ADDRESS_ID)
            this.selectedId = id || this.recipients[0].id
            this.loading = false
        },
        confirm() {
            setStorage(ADDRESS_ID, this.selectedId)
            this.$router.push(this.from)
        }
    },
    created() {
        this.initData()
    }
}
</script>
<style lang="less">
.address-list{
    .van-address-list__bottom{
        bottom: 2.65rem !important;
    }
}
</style>